<header class="navbar navbar-expand-lg navbar-light fixed-top home_navbar">
  <div class="container relative menu_inner">
    <a class="logo navbar-brand" href="index.html">
      <img src="{{imageUrl+arkLogo}}" alt="Deck Pro">
      <!-- <img src="../../assets/img/ark_tech_logo_white.png" alt="Deck Pro"> -->
    </a>

    <div class="desktop_inner">
      <div class="mob-menu">
        <a *ngIf="!loginFlag" href="#loginform" data-toggle="collapse" class="collapsed" data-target="#loginform">
          <i class="fa fa-sign-in-alt"></i>
        </a>
        <button id="menu-toggle" class="btn btn-toggle" (click)="toggleMenu()"><i class="fa fa-bars"></i></button>

        <!-- <a href="index.html" class="logo2 small_logo"><img src="{{imageUrl+deckproLogo}}" alt="deckLogo"></a> -->
      </div>

      <nav id="navigation">
        <ul id="main-menu" [ngClass]="{'show': isMenuOpen && isMobileView}">
          <!-- <li *ngIf="!isMobileView"><span class="arrow">▼</span></li>
          <li class="header_language">
            <a class="language-dropdown">
              <select [(ngModel)]="langId" (change)="onLanguageChange()">
                <option [value]="item?.id" *ngFor="let item of languageArray">
                  {{ item?.displayName }}
                </option>
              </select>
            </a>
          </li> -->

          <li><a href="/resource-centre" translate>Resource Center</a></li>
          <li *ngIf="!loginFlag"><a href="/register" translate>Register</a></li>

          <li *ngIf="!isMobileView && !loginFlag"><a href="#loginform" data-toggle="collapse" class="collapsed"
              data-target="#loginform" translate>Log In</a></li>

          <li class="parent" *ngIf="loginFlag && representative && !isMobileView"><a href="javascript:;">Contact Your
              Representative <i class="fa fa-angle-down"></i></a>
            <ul class="sub-menu custom-list">
              <li *ngIf="representative?.salesRep?.name" class="custom-list-title">Sale Representative</li>
              <li *ngIf="representative?.salesRep?.name" class="custom-list-item"><b> Name : </b>
                {{representative?.salesRep?.name}}</li>
              <li *ngIf="representative?.salesRep?.email" class="custom-list-item"><b> Email : </b>
                {{representative?.salesRep?.email}}</li>
              <li *ngIf="representative?.salesRep?.phone" class="custom-list-item"><b> Phone : </b>
                {{representative?.salesRep?.phone}}</li>

              <li *ngIf="representative?.opeRep1?.name" class="custom-list-title">Operations Representative</li>
              <li *ngIf="representative?.opeRep1?.name" class="custom-list-item"><b> Name : </b>
                {{representative?.opeRep1?.name}}</li>
              <li *ngIf="representative?.opeRep1?.email" class="custom-list-item"><b> Email : </b>
                {{representative?.opeRep1?.email}} </li>
              <li *ngIf="representative?.opeRep1?.phone" class="custom-list-item"><b> Phone : </b>
                {{representative?.opeRep1?.phone}}</li>

              <li *ngIf="representative?.opeRep2?.name" class="custom-list-title">Secondary Operations Representative
              </li>
              <li *ngIf="representative?.opeRep2?.name" class="custom-list-item"><b> Name : </b>
                {{representative?.opeRep2?.name}}</li>
              <li *ngIf="representative?.opeRep2?.name" class="custom-list-item"><b> Email : </b>
                {{representative?.opeRep2?.email}}</li>
              <li *ngIf="representative?.opeRep2?.name" class="custom-list-item"><b> Phone : </b>
                {{representative?.opeRep2?.phone}}</li>
            </ul>
          </li>




          <ng-container *ngIf="loginFlag && representative && isMobileView">
            <li><a href="javascript:;">Contact Your Representative <i class="fa fa-angle-down"></i></a></li>

            <!-- Sales Representative -->
            <li class="Mob-Rep" *ngIf="representative?.salesRep?.name">
              <a href="javascript:;" style="font-weight: bold;" translate>Sales Representative
                <li *ngIf="representative?.salesRep?.name" style="padding-left: 30px;"><a href="javascript:;">
                  {{ 'Name' | translate }}: {{ representative?.salesRep?.name }}</a></li>
                <li *ngIf="representative?.salesRep?.email" style="padding-left: 30px;"><a href="javascript:;">
                  {{ 'Email' | translate }}: {{ representative?.salesRep?.email }}</a></li>
                <li *ngIf="representative?.salesRep?.phone" style="padding-left: 30px;"><a href="javascript:;">
                  {{ 'Phone' | translate }}: {{ representative?.salesRep?.phone }}</a></li>
            </a>
            </li>

            <!-- Operations Representative -->
            <li *ngIf="representative?.opeRep1?.name">
              <a href="javascript:;" style="font-weight: bold;" translate>Operations Representative
                <li *ngIf="representative?.opeRep1?.name" style="padding-left: 30px;"><a href="javascript:;">
                  {{ 'Name' | translate }}: {{ representative?.opeRep1?.name }}</a></li>
                <li *ngIf="representative?.opeRep1?.email" style="padding-left: 30px;"><a href="javascript:;">
                  {{ 'Email' | translate }}: {{ representative?.opeRep1?.email }}</a></li>
                <li *ngIf="representative?.opeRep1?.phone" style="padding-left: 30px;"><a href="javascript:;">
                  {{ 'Phone' | translate }}: {{ representative?.opeRep1?.phone }}</a></li>
            </a>
            </li>

            <!-- Secondary Operations Representative -->
            <li *ngIf="representative?.opeRep2?.name">
              <a href="javascript:;" style="font-weight: bold;" translate>Secondary Operations Representative
                <li *ngIf="representative?.opeRep2?.name" style="padding-left: 30px;"><a href="javascript:;">
                  {{ 'Name' | translate }}: {{ representative?.opeRep2?.name }}</a></li>
                <li *ngIf="representative?.opeRep2?.email" style="padding-left: 30px;"><a href="javascript:;">
                  {{ 'Email' | translate }}: {{ representative?.opeRep2?.email }}</a></li>
                <li *ngIf="representative?.opeRep2?.phone" style="padding-left: 30px;"><a href="javascript:;">
                  {{ 'Phone' | translate }}: {{ representative?.opeRep2?.phone }}</a></li>
              </a>
            </li>
          </ng-container>

          <li class="parent" *ngIf="loginFlag && !isMobileView">
            <a href="javascript:;">Hi {{userData?.firstName}} <i class="fa fa-angle-down"></i></a>
            <ul class="sub-menu">
              <li><a href="/profile">My Account</a></li>
              <li (click)="logout()"><a href="jabascript:;" class="logMenu">Logout</a></li>
            </ul>
          </li>

          <ng-container *ngIf="isMobileView">
            <li class="parent" *ngIf="loginFlag">
              <a href="javascript:;">Hi {{userData?.firstName}} <i class="fa fa-angle-down"></i>
            <li style="padding-left: 30px;"><a href="/profile">My Account</a></li>
            <li style="padding-left: 30px;" (click)="logout()"><a href="jabascript:;" class="logMenu">Logout</a></li>
            </a>
            </li>
          </ng-container>


        </ul>
      </nav>

      <form class="login-form sub-menu collapse" id="loginform" #f="ngForm" (ngSubmit)="onSubmit(f)">
        <ul class="nav nav-tabs">
          <li class="nav-item"><a class="nav-link text-uppercase active" id="agentlogin-tab" data-toggle="tab"
              href="#agentlogin" role="tab" translate>Agent Login</a>
            <!-- <span class="close-button" onclick="document.getElementById('loginform').classList.toggle('collapse');">×</span> -->
          </li>
        </ul>
        <div class="tab-content" id="loginTabContent">
          <div class="tab-pane fade active show" id="agentlogin" role="tabpanel" aria-labelledby="agentlogin-tab">
            <div *ngIf="errorMessage" class="alert alert-danger alert_class">{{errorMessage}}</div>
            <div *ngIf="successMassage" class="alert alert-success alert_class">{{successMassage}}</div>
            <div class="form-group">
              <div class="input-group-icon">
                <span class="icon"><img src="../../assets/images/icons/user.png"></span>
                <input class="form-control" type="email" placeholder="Email id" [(ngModel)]="formData.email"
                  name="email" required>
              </div>
            </div>
            <div class="form-group">
              <div class="input-group-icon">
                <span class="icon"><img src="../../assets/images/icons/password.png"></span>
                <input class="form-control" type="password" placeholder="Password" [(ngModel)]="formData.password"
                  name="Password" required>
              </div>
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-nav btn-danger text-uppercase" translate>Log In</button>
            </div>
            <div class="form-group text-center"><a href="javascript:;" data-toggle="modal"
                data-target="#forgotPasswordModal" translate>
                Forgot Your Password? Get Help</a>
            </div>
          </div>
        </div>
      </form>
      <a href="index.html" class="logo2">
        <img src="{{imageUrl+deckproLogo}}" alt="">
      </a>
    </div>
  </div>
</header>

<!-- Forgot Password Modal -->
<div class="modal fade" id="forgotPasswordModal" tabindex="-1" aria-labelledby="forgotPasswordModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header text-white" style="background-color: #ab815a;">
        <h5 class="modal-title" id="forgotPasswordModalLabel">Forget password ?</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <form #r="ngForm" (ngSubmit)="resetPassword(r)">
        <div class="modal-body">
          <!-- Error message (example, show conditionally) -->
          <div *ngIf="resetErrorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
            {{ resetErrorMessage }}
            <button type="button" class="btn-close" (click)="resetErrorMessage=''" aria-label="Close"></button>
          </div>
          <div *ngIf="resetSuccessMessage" class="alert alert-success alert-dismissible fade show" role="alert">
            {{ resetSuccessMessage }}
            <button type="button" class="btn-close" (click)="resetSuccessMessage=''" aria-label="Close"></button>
          </div>

          <p>If you have forgotten your password you can reset it here.</p>

          <div class="form-group">
            <input type="email" name="forgotEmail" class="form-control" placeholder="Enter your email"
              [(ngModel)]="forgotEmail" required email #forgot="ngModel" />
            <div *ngIf="r.submitted && forgot.errors" class="text-danger mt-1 small">
              <div *ngIf="forgot.errors['required']">Email is required.</div>
              <div *ngIf="forgot.errors['email']">Please enter a valid email.</div>
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer d-block text-center">
          <button type="submit" class="btn btn-primary w-100">Reset Password</button>
        </div>
      </form>

    </div>
  </div>
</div>